__turbopack_context__.v({
  "fadeOnHover": "dSu21W_fadeOnHover",
  "fadeOverlay": "dSu21W_fadeOverlay",
  "label": "dSu21W_label",
  "labelSelected": "dSu21W_labelSelected",
  "radioIndicator": "dSu21W_radioIndicator",
  "radioIndicatorError": "dSu21W_radioIndicatorError",
  "radioIndicatorSelected": "dSu21W_radioIndicatorSelected",
});
